import { useMemo } from 'react';

import { LabelId, UserCommunication } from '@this+that/models';

export interface SelectedItemsReadStatus {
  hasOnlyReadItems: boolean;
  hasOnlyUnreadItems: boolean;
  hasMixedItems: boolean;
}

export function useCheckSelectedItemsReadStatus(
  communications: UserCommunication[],
  selectedItems: Set<string>,
): SelectedItemsReadStatus {
  return useMemo(() => {
    if (selectedItems.size === 0) {
      return {
        hasOnlyReadItems: false,
        hasOnlyUnreadItems: false,
        hasMixedItems: false,
      };
    }

    const selectedCommunications = communications.filter((comm) =>
      selectedItems.has(comm.messageId),
    );

    const unreadCount = selectedCommunications.filter((comm) =>
      comm.labelIds?.includes(LabelId.UNREAD),
    ).length;

    const readCount = selectedCommunications.length - unreadCount;

    const hasOnlyReadItems = readCount > 0 && unreadCount === 0;
    const hasOnlyUnreadItems = unreadCount > 0 && readCount === 0;
    const hasMixedItems = readCount > 0 && unreadCount > 0;

    return {
      hasOnlyReadItems,
      hasOnlyUnreadItems,
      hasMixedItems,
    };
  }, [communications, selectedItems]);
}
